import { create } from 'zustand'
import { api } from '../lib/api'

interface OnboardingStatusState {
  stage: string | null
  /** Gates whether a new conversation auto-fires the engine's onboarding kickoff turn. */
  isNewTenant: boolean
  loading: boolean
  error: string | null
  fetchStatus: () => Promise<void>
}

interface OnboardingStatusResponse {
  stage: string
  isNewTenant: boolean
  equipmentCount: number
}

export const useOnboardingStatusStore = create<OnboardingStatusState>((set) => ({
  stage: null,
  isNewTenant: false,
  loading: false,
  error: null,

  fetchStatus: async () => {
    set({ loading: true, error: null })
    try {
      const res = await api.get<OnboardingStatusResponse>('/api/v1/users/onboarding-status')
      set({
        stage: res.stage,
        isNewTenant: res.isNewTenant,
        loading: false,
      })
    } catch (err) {
      // Fail-safe: chat must not be blocked when the engine is unreachable
      set({
        isNewTenant: false,
        loading: false,
        error: err instanceof Error ? err.message : String(err),
      })
    }
  },
}))
